function normalizeBaseUrl(url: string): string {
  const trimmed = url.trim();
  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
}

/**
 * Vite replaces `import.meta.env.*` at build time.
 * In some local/docker setups `VITE_API_BASE_URL` may end up missing,
 * so we provide a safe fallback to avoid `undefined/...` requests.
 */
const API_V1_BASE_URL = normalizeBaseUrl(
  (import.meta.env.VITE_API_BASE_URL && String(import.meta.env.VITE_API_BASE_URL)) ||
    (import.meta.env.DEV ? 'http://localhost:5001/api' : '/api')
);

/**
 * The dashboard talks to the organization-aware v2 API: every request is
 * authenticated (JWT) and scoped to the logged-in user's organization.
 * `VITE_API_BASE_URL` keeps pointing at the classic `/api` root; `/v2` is
 * appended here so a misconfigured env var can't silently downgrade to v1.
 */
export const API_BASE_URL = API_V1_BASE_URL.endsWith('/v2')
  ? API_V1_BASE_URL
  : `${API_V1_BASE_URL}/v2`;

/**
 * Authorization header for the logged-in user. v2 requires authentication on
 * every route (including reads), so all API calls should spread this in.
 */
export function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}
